import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  query: "",
};

const tasksSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {
    searchTask: (state, action) => {
      state.query = action.payload;
    },
  },
});

export const { searchTask } = tasksSlice.actions;
export default tasksSlice.reducer;
